// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import JobMgrOutlinedSvg from "@fishx/icons-svg/es/asn/JobMgrOutlined";
import FishxIcon from '../components/FishxIcon';

var JobMgrOutlined = function JobMgrOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: JobMgrOutlinedSvg
  }));
};

JobMgrOutlined.displayName = 'JobMgrOutlined';
export default React.forwardRef(JobMgrOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/JobMgrOutlined.js
// module id = 3006
// module chunks = 0